import React, { useContext, useState } from "react";
import { PhrasesContext } from "../../../context/phrasesContext";
import { USDollar } from "../../../utils/helpers";
import { Link } from "react-router-dom";
import { downloadReceipt } from "../../../services/Common";
import { Loader } from "../../utils";
const ServiceValue = ({
  claimedValue,
  serviceStatusId,
  setOpenModal,
  successUploadReciept,
  service,
}) => {
  const lang = window.localStorage.getItem("lang");
  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [loading, setLoading] = useState(false);

  const getDownloadReceipt = () => {
    setLoading(true);
    downloadReceipt(service?.id).then(
      (blob) => {
        if (!blob) {
          console.error("Failed to download file");
          return;
        }

        const url = window.URL.createObjectURL(blob);

        // Create a temporary link and trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.download = "Receipt.pdf"; // You can extract filename from `content-disposition` if needed
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoading(false);
      },
      (err) => {
        console.log("Fail Payment !!!!!", err);
      }
    );
  };

  console.log("service", service);
  return (
    <div className="w-full ">
      {(service?.serviceStatusId === 4 ||
        service?.serviceStatusId === 5 ||
        service?.serviceStatusId === 6 ||
        service?.serviceStatusId === 7 ||
        service?.serviceStatusId === 3) &&
      (service.isUploadReceipts === true || service.isPaid === true) ? (
        <div
          className={`flex justify-between items-center w-full bg-background-PaymednBtn  bg-[#b68a35] bg-no-repeat  ${
            lang === "en"
              ? "bg-none md:bg-background-PaymednBtn md:bg-right !bg-[length:25%] "
              : "bg-left bg-contain"
          }  px-[24px] py-5 h-[86px]`}
        >
          <div className="flex flex-row items-center justify-center gap-[24px]">
            <img
              src="/assets/img/Waiting-approval.svg"
              alt="Waiting-approval"
              className=""
            />
            {(service?.isPaid === true && service?.isUploadReceipts === true) ||
            (service?.isPaid === true &&
              service?.isUploadReceipts === false) ? (
              <p className="text-[14px] md:text-[18px] font-Almarai font-bold leading-[1.71]  text-[#fff]">
                {lang === "en"
                  ? enPhrase["lblPaymentIsSuccess"]
                  : arPhrase["lblPaymentIsSuccess"]}
              </p>
            ) : (
              service?.isPaid === false &&
              service?.isUploadReceipts === true && (
                <p className="text-[14px] md:text-[18px] font-Almarai font-bold leading-[1.71]  text-[#fff]">
                  {lang === "en"
                    ? enPhrase["lblReceiptUnderReview"]
                    : arPhrase["lblReceiptUnderReview"]}
                </p>
              )
            )}
          </div>

          {service?.isPaid === true && (
            <button
              className={`flex flex-row justify-center items-center gap-2  h-[48px] text-sm font-bold bg-[#F2ECCF] px-3 rounded-3 text-white ${
                lang === "en"
                  ? "w-[120px] md:w-[220px]"
                  : "w-[160px] md:w-[180px]"
              }`}
              onClick={getDownloadReceipt}
            >
              <span className="text-[14px] md:text-[16px] font-Almarai font-[700] text-[#815327] leading-normal">
                {lang === "en"
                  ? enPhrase["lblDownloadReceipt"]
                  : arPhrase["lblDownloadReceipt"]}
              </span>
              {loading ? <Loader color={"#815327"} /> : null}
            </button>
          )}
        </div>
      ) : (
        <div className="flex justify-between items-center w-full bg-background-PaymednBtn bg-contain bg-[#b68a35] bg-no-repeat bg-left  px-[24px] py-5 h-[86px]">
          <div>
            <p className="text-[16px] text-[#FFFFFF] leading-[24px] mb-[2px] font-Almarai md:h-[14px] md:mb-[5px]">
              {lang === "en"
                ? enPhrase["lblServiceValue"]
                : arPhrase["lblServiceValue"]}
            </p>
            {/* <p
              className={`flex ${
                lang === "en" ? "flex-row-reverse" : "flex-row"
              } items-center gap-[7px] text-2xl text-[#FFFFFF] leading-normal md:h-[27px]`}
            >
              <span className="font-bold text-[24px]">
                {USDollar.format(claimedValue)}{" "}
              </span>
              <span className="text-muted small text-decoration-line-through !text-[#FFFFFF]  flex items-center h-full">
                <span
                  className="uae-symbol  !text-[#FFFFFF] !leading-[0px] !text-[24px] md:font-medium"
                  lang="en"
                  dir="ltr"
                >
                  &#x00EA;
                </span>
              </span>
            </p> */}
            {/* <div
              className={`flex ${
                lang === "en" ? "flex-row-reverse" : ""
              }  gap-[3px] items-center justify-center`}
            >
              <p className="text-[20px] text-[#FFFFFF] font-Almarai">
                {USDollar.format(claimedValue)}
              </p>
              <span className="text-muted small text-decoration-line-through !text-[#FFFFFF]  flex items-center h-full">
                <span
                  className="uae-symbol  !text-[#FFFFFF] !leading-[0px] text-xl md:font-medium"
                  lang="en"
                  dir="ltr"
                >
                  &#x00EA;
                </span>
              </span>
             
            </div> */}

            <div
              className={`flex ${
                lang === "en" ? "flex-row-reverse" : ""
              }  gap-[3px] items-center justify-center`}
            >
              <p className="text-[22px] text-[#fff] font-Almarai font-bold">
                {USDollar.format(service?.serviceValue)}
              </p>
              <span className="text-muted small text-decoration-line-through !text-[#fff] flex items-center h-full">
                <span
                  className="uae-symbol  !text-[#fff] !text-[20px] !leading-[0px] text-xl md:font-[600]"
                  lang="en"
                  dir="ltr"
                >
                  &#x00EA;
                </span>
              </span>
            </div>
          </div>

          {/* New Update */}
          {serviceStatusId === 3 &&
          service?.isUploadReceipts !== true &&
          service?.caseNumber !== null &&
          service?.caseNumber !== "" ? (
            <Link
              to={`/payment-method/${service.caseId}/${service.id}`}
              className={`flex ${
                lang === "en" ? " w-[180px]" : " w-[166px]"
              } flex-row-reverse justify-center font-Almarai items-center gap-[8px] transition-all duration-300 px-[12px] font-semibold md:px-1 lg:px-4 xl:px-[12px] h-[44px] text-sm border-2 text-[#815327] bg-[#FFF] border-[#815327] rounded focus:outline-none`}
            >
              <span className=" h-[18px] text-[13px] font-bold font-Almarai drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]">
                {lang === "en"
                  ? enPhrase["lblPaymentMethod"]
                  : arPhrase["lblPaymentMethod"]}
              </span>
              <img
                src="/assets/img/button/receipt.svg"
                alt="receipt"
                className="w-5 h-5"
              />
            </Link>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default ServiceValue;
